import { Box, IconButton, List, ListItem, Paper, TextField, Tooltip, Typography } from '@mui/material'
import React, { useContext, useState } from 'react'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { ThemeContext } from '../../context/ThemeContext';
import { useTranslation } from 'react-i18next';
import EditAlertDialog from '../../components/tab/tabview/alert/EditAlertDialog';
import DeleteAlert from '../../components/tab/tabview/alert/DeleteAlert';
import { useDispatch, useSelector } from 'react-redux';
import { MdNotifications } from "react-icons/md";
import { MdOutlineEdit } from "react-icons/md";
import { MdDeleteOutline } from "react-icons/md";
import { deleteAlert, updateAlert } from '../../api/request/dashboard/dashboard';
import { deleteAlertData, updateAlertData } from '../../store/Slices/alertSlice';
import toast from 'react-hot-toast';
import NewAlert from '../../components/tab/tabview/alert/NewAlert';
// create alert pending

export default function Alert() {
  const { darkMode } = useContext(ThemeContext)
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const { symbols } = useSelector(state => state.watchlist)
  const { alert = [] } = useSelector(state => state.alert)
  const [selectedAlert, setSelectedAlert] = useState(null);
  const accountId = localStorage.getItem("accountID");
  const [searchQuery, setSearchQuery] = useState('');

  const handleOpen = () => setOpen(true);

  // const typeMap = {
  //   1: "alert_type_sound",
  //   2: "alert_type_sms",
  // };

  const conditionMap = {
    1: "condition_bid_gt",
    2: "condition_bid_lt",
    3: "condition_ask_gt",
    4: "condition_ask_lt",
    5: "condition_balance_gt",
    6: "condition_balance_lt",
    7: "condition_equity_gt",
    8: "condition_equity_lt",
    9: "condition_marginlevel_gt",
    10: "condition_marginlevel_lt",
    11: "condition_pl_gt",
    12: "condition_pl_lt",
  };
  const handleEditClick = (alert) => {
    setSelectedAlert(alert);
    setEditOpen(true);
  };

  const handleDeleteClick = (alert) => {
    setSelectedAlert(alert);
    setDeleteOpen(true);
  };
  const handleDelete = async () => {
    if (!selectedAlert) {
      console.error("No alert selected for deletion.");
      return;
    }

    let data = { id: selectedAlert.id, accountId };

    try {
      await deleteAlert(data);
      dispatch(deleteAlertData(selectedAlert.id))
      toast.success("Alert deleted successfully!");
      setDeleteOpen(false);;
    } catch (error) {
      console.error("Error deleting alert:", error);
      toast.error("Failed to delete alert.");
    }
  };
  const handleUpdate = async (updatedAlert) => {
    try {
      console.log("Updated Alert Payload:", updatedAlert);

      // Ensure proper data structure
      const sanitizedPayload = {
        id: updatedAlert.id,
        accountId: Number(updatedAlert.accountId),  // Ensure it's a number
        symbolId: updatedAlert.symbolId ? Number(updatedAlert.symbolId) : null,
        condition: updatedAlert.condition,
        type: updatedAlert.type,
        value: updatedAlert.value,
        enabled: updatedAlert.enabled,
        hitPrice: updatedAlert.hitPrice ? updatedAlert.hitPrice : null,  // Ensure it's a number
      };

      console.log("Sanitized Payload:", sanitizedPayload);

      const response = await updateAlert(sanitizedPayload);
      console.log("API Response:", response);

      if (response.status === 200) {
        toast.success("Alert updated successfully!");
        dispatch(updateAlertData(alert.map(alert => alert.id === updatedAlert.id ? updatedAlert : alert)));
        setEditOpen(false);
      }
    } catch (error) {
      console.error("Error updating alert:", error);
      toast.error("Failed to update alert.");
    }
  };
  const filteredAlerts = alert.filter((alertItem) => {
    const query = searchQuery.toLowerCase();
    const conditionKey = conditionMap[alertItem.condition] || '';
    const conditionText = t(conditionKey).toLowerCase();

    return (conditionText.includes(query));
  });

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
        <Box flex={1} display="flex" justifyContent="center">
          <Typography sx={{ color: darkMode ? "var(--lightText)" : "var(--darkText)" }}>{t('alerts')}</Typography>
        </Box>
        <Tooltip title={t('createAlert')}><IconButton onClick={handleOpen}><AddCircleOutlineIcon sx={{ fontSize: 20 }} /></IconButton>
        </Tooltip>
      </Box>
      <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff" }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Paper sx={{ display: "flex", alignItems: "center", borderRadius: 0, width: "100%", padding: 0, backgroundColor: darkMode ? "#202933" : "#f1f1f1", }}>
            <TextField size="small" variant="outlined" placeholder="Search here..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ "& fieldset": { border: "none" }, flex: 1 }} />
          </Paper>
        </Box>
      </Box>
      {/* <Divider /> */}

      <List sx={{ backgroundColor: darkMode ? "#151924" : "#fff", padding: 0 }}>
        {filteredAlerts.map((item, index) => {
          const isHit = !item.enabled;
          return (
            <ListItem key={index} sx={{ display: "flex", flexDirection: "row", borderBottom: `1px solid ${darkMode ? "var(--borderDark)" : "var(--borderLight)"}`, py: 2, px: 1, gap: 3, }}>
              <Box sx={{ display: "flex", alignItems: "start", pt: "6px" }}>
                <MdNotifications style={{ color: isHit ? "gold" : "green", fontSize: 28 }} />
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
                <Typography variant="subtitle1" sx={{ color: darkMode ? "#fff" : "#000", fontWeight: 500 }}>
                  {t(conditionMap[item.condition])} {item.value}
                  {isHit && (
                    <>
                      <br />{t('alertHit')} {item.hitPrice}
                    </>
                  )}
                </Typography>

                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
                  <Typography variant="body2" color="textSecondary">{t('date')}: {item.hitDateTime ? item.hitDateTime : "NA"}</Typography>
                </Box>
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
                <Tooltip title={t('editAlert')}><MdOutlineEdit onClick={() => handleEditClick(item)} style={{ fontSize: 20, color: 'var(--primary)' }} /></Tooltip>
                <Tooltip title={t('deleteAlert')}>  <MdDeleteOutline onClick={() => handleDeleteClick(item)} style={{ fontSize: 20, color: "red" }} /></Tooltip>
              </Box>
            </ListItem>
          );
        })}
      </List>

      {open && (<NewAlert open={open} onClose={() => setOpen(false)} />)}
      <EditAlertDialog open={editOpen} handleClose={() => setEditOpen(false)} alertData={selectedAlert} symbolData={symbols} handleUpdate={handleUpdate} />
      <DeleteAlert open={deleteOpen} handleClose={() => setDeleteOpen(false)} handleDelete={handleDelete} />
    </>
  )
}
